import React from 'react';
import { useParams } from 'react-router-dom';
import { usePieceDetails } from './usePieceDetails';
import { getStatusConfig, getId } from './PieceDetailsPage.helpers';
import { PieceEventRow } from './PieceEventRow';
import css from './PieceDetailsPage.css';

const StatusBadge = ({ status }) => {
  const { label, badgeClass } = getStatusConfig(status);
  return <span className={`${css.statusBadge} ${badgeClass}`}>{label}</span>;
};

export const PieceDetailsPage = () => {
  const { pieceId } = useParams();
  const {
    pieceAttrs,
    productTitle,
    currentStoreName,
    sortedEvents,
    hasPieceData,
    isLoading,
    isError,
    isEventsFetching,
  } = usePieceDetails(pieceId);

  if (isLoading) {
    return (
      <div className={css.container}>
        <div className={css.spinner} />
      </div>
    );
  }

  if (isError) {
    return (
      <div className={css.container}>
        <div className={css.errorInsideLayout}>
          Wystąpił błąd podczas pobierania danych sztuki. Spróbuj ponownie.
        </div>
      </div>
    );
  }

  if (!hasPieceData) {
    return (
      <div className={css.container}>
        <div className={css.noResults}>Nie znaleziono takiej sztuki.</div>
      </div>
    );
  }

  return (
    <div className={css.container}>
      <header className={css.headerWrapper}>
        <div className={css.headerInfo}>
          <h1 className={css.title}>Szczegóły sztuki: {pieceAttrs?.code || '-'}</h1>

          <div className={css.metaDetailsGroup}>
            <div className={css.metaRow}>
              <span className={css.metaLabel}>Produkt:</span>
              <span className={css.metaValue}>{productTitle}</span>
            </div>
            <div className={css.metaRow}>
              <span className={css.metaLabel}>Obecny sklep:</span>
              <span className={css.metaValue}>{currentStoreName}</span>
            </div>
          </div>

          <div className={css.metaInfo}>
            <span className={css.metaLabel}>Obecny status:</span>
            <StatusBadge status={pieceAttrs?.state || pieceAttrs?.status} />
          </div>
        </div>

        <div className={css.headerActions}>
          {/* <button type="button" className={css.primaryButton}>Edytuj sztukę</button> */}
        </div>
      </header>

      <section className={`${css.eventsSection} ${isEventsFetching ? css.fetchingMode : ''}`}>
        <h2 className={css.sectionTitle}>Historia sztuki</h2>

        {sortedEvents.length === 0 ? (
          <div className={css.noResults}>Brak zdefiniowanych zdarzeń dla tej sztuki.</div>
        ) : (
          <div className={css.tableContainer}>
            <div className={css.tableHeader}>
              <div className={css.tableHeaderCell}>Data</div>
              <div className={css.tableHeaderCell}>Zmiana</div>
              <div className={css.tableHeaderCell}>Dodatkowe info</div>
              <div className={css.tableHeaderCell}>Użytkownik</div>
            </div>

            <div className={css.tableBody}>
              {sortedEvents.map((event) => {
                const eventKey = getId(event.id) || event.id;
                return <PieceEventRow key={eventKey} event={event} />;
              })}
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default PieceDetailsPage;